function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.23
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.1019,
  cy: 162.917,
  r: 2.4,
  transform: "rotate(-45 11.1019 162.917)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.1019,
  cy: 162.917,
  r: 2.4,
  transform: "rotate(-45 11.1019 162.917)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.4962,
  cy: 130.107,
  r: 2.4,
  transform: "rotate(-45 14.4962 130.107)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29.2039,
  cy: 144.815,
  r: 2.4,
  transform: "rotate(-45 29.2039 144.815)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.598,
  cy: 112.006,
  r: 2.4,
  transform: "rotate(-45 32.598 112.006)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47.3057,
  cy: 126.713,
  r: 2.4,
  transform: "rotate(-45 47.3057 126.713)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50.7,
  cy: 93.9036,
  r: 2.4,
  transform: "rotate(-45 50.7 93.9036)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65.4078,
  cy: 108.612,
  r: 2.4,
  transform: "rotate(-45 65.4078 108.612)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68.8018,
  cy: 75.8018,
  r: 2.4,
  transform: "rotate(-45 68.8018 75.8018)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83.5096,
  cy: 90.5095,
  r: 2.4,
  transform: "rotate(-45 83.5096 90.5095)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86.9039,
  cy: 57.6997,
  r: 2.4,
  transform: "rotate(-45 86.9039 57.6997)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101.612,
  cy: 72.4077,
  r: 2.4,
  transform: "rotate(-45 101.612 72.4077)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105.006,
  cy: 39.5979,
  r: 2.4,
  transform: "rotate(-45 105.006 39.5979)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119.713,
  cy: 54.3057,
  r: 2.4,
  transform: "rotate(-45 119.713 54.3057)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123.108,
  cy: 21.4958,
  r: 2.4,
  transform: "rotate(-45 123.108 21.4958)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137.816,
  cy: 36.2039,
  r: 2.4,
  transform: "rotate(-45 137.816 36.2039)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141.21,
  cy: 3.39404,
  r: 2.4,
  transform: "rotate(-45 141.21 3.39404)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155.917,
  cy: 18.1018,
  r: 2.4,
  transform: "rotate(-45 155.917 18.1018)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.8096,
  cy: 177.625,
  r: 2.4,
  transform: "rotate(-45 25.8096 177.625)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.8096,
  cy: 177.625,
  r: 2.4,
  transform: "rotate(-45 25.8096 177.625)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43.9117,
  cy: 159.523,
  r: 2.4,
  transform: "rotate(-45 43.9117 159.523)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62.0137,
  cy: 141.421,
  r: 2.4,
  transform: "rotate(-45 62.0137 141.421)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80.1155,
  cy: 123.319,
  r: 2.4,
  transform: "rotate(-45 80.1155 123.319)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98.2176,
  cy: 105.217,
  r: 2.4,
  transform: "rotate(-45 98.2176 105.217)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116.319,
  cy: 87.1155,
  r: 2.4,
  transform: "rotate(-45 116.319 87.1155)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134.421,
  cy: 69.0134,
  r: 2.4,
  transform: "rotate(-45 134.421 69.0134)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152.523,
  cy: 50.9116,
  r: 2.4,
  transform: "rotate(-45 152.523 50.9116)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170.625,
  cy: 32.8096,
  r: 2.4,
  transform: "rotate(-45 170.625 32.8096)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40.5176,
  cy: 192.333,
  r: 2.4,
  transform: "rotate(-45 40.5176 192.333)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40.5176,
  cy: 192.333,
  r: 2.4,
  transform: "rotate(-45 40.5176 192.333)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58.6195,
  cy: 174.231,
  r: 2.4,
  transform: "rotate(-45 58.6195 174.231)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76.7215,
  cy: 156.129,
  r: 2.4,
  transform: "rotate(-45 76.7215 156.129)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94.8233,
  cy: 138.027,
  r: 2.4,
  transform: "rotate(-45 94.8233 138.027)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112.925,
  cy: 119.925,
  r: 2.4,
  transform: "rotate(-45 112.925 119.925)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131.027,
  cy: 101.823,
  r: 2.4,
  transform: "rotate(-45 131.027 101.823)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149.129,
  cy: 83.7214,
  r: 2.4,
  transform: "rotate(-45 149.129 83.7214)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167.231,
  cy: 65.6194,
  r: 2.4,
  transform: "rotate(-45 167.231 65.6194)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185.333,
  cy: 47.5176,
  r: 2.4,
  transform: "rotate(-45 185.333 47.5176)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55.2254,
  cy: 207.041,
  r: 2.4,
  transform: "rotate(-45 55.2254 207.041)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55.2254,
  cy: 207.041,
  r: 2.4,
  transform: "rotate(-45 55.2254 207.041)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73.3272,
  cy: 188.939,
  r: 2.4,
  transform: "rotate(-45 73.3272 188.939)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91.4293,
  cy: 170.837,
  r: 2.4,
  transform: "rotate(-45 91.4293 170.837)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109.531,
  cy: 152.735,
  r: 2.4,
  transform: "rotate(-45 109.531 152.735)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127.633,
  cy: 134.633,
  r: 2.4,
  transform: "rotate(-45 127.633 134.633)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145.735,
  cy: 116.531,
  r: 2.4,
  transform: "rotate(-45 145.735 116.531)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163.837,
  cy: 98.4292,
  r: 2.4,
  transform: "rotate(-45 163.837 98.4292)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181.939,
  cy: 80.3271,
  r: 2.4,
  transform: "rotate(-45 181.939 80.3271)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 200.041,
  cy: 62.2253,
  r: 2.4,
  transform: "rotate(-45 200.041 62.2253)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69.9332,
  cy: 221.749,
  r: 2.4,
  transform: "rotate(-45 69.9332 221.749)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69.9332,
  cy: 221.749,
  r: 2.4,
  transform: "rotate(-45 69.9332 221.749)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88.0352,
  cy: 203.647,
  r: 2.4,
  transform: "rotate(-45 88.0352 203.647)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106.137,
  cy: 185.545,
  r: 2.4,
  transform: "rotate(-45 106.137 185.545)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124.239,
  cy: 167.443,
  r: 2.4,
  transform: "rotate(-45 124.239 167.443)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142.341,
  cy: 149.341,
  r: 2.4,
  transform: "rotate(-45 142.341 149.341)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160.443,
  cy: 131.239,
  r: 2.4,
  transform: "rotate(-45 160.443 131.239)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178.545,
  cy: 113.137,
  r: 2.4,
  transform: "rotate(-45 178.545 113.137)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 196.647,
  cy: 95.0352,
  r: 2.4,
  transform: "rotate(-45 196.647 95.0352)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 214.749,
  cy: 76.9331,
  r: 2.4,
  transform: "rotate(-45 214.749 76.9331)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84.6409,
  cy: 236.456,
  r: 2.4,
  transform: "rotate(-45 84.6409 236.456)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84.6409,
  cy: 236.456,
  r: 2.4,
  transform: "rotate(-45 84.6409 236.456)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102.743,
  cy: 218.354,
  r: 2.4,
  transform: "rotate(-45 102.743 218.354)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120.845,
  cy: 200.252,
  r: 2.4,
  transform: "rotate(-45 120.845 200.252)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138.947,
  cy: 182.151,
  r: 2.4,
  transform: "rotate(-45 138.947 182.151)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157.049,
  cy: 164.049,
  r: 2.4,
  transform: "rotate(-45 157.049 164.049)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175.151,
  cy: 145.947,
  r: 2.4,
  transform: "rotate(-45 175.151 145.947)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 193.253,
  cy: 127.845,
  r: 2.4,
  transform: "rotate(-45 193.253 127.845)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 211.355,
  cy: 109.743,
  r: 2.4,
  transform: "rotate(-45 211.355 109.743)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 229.456,
  cy: 91.6409,
  r: 2.4,
  transform: "rotate(-45 229.456 91.6409)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99.3489,
  cy: 251.164,
  r: 2.4,
  transform: "rotate(-45 99.3489 251.164)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99.3489,
  cy: 251.164,
  r: 2.4,
  transform: "rotate(-45 99.3489 251.164)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117.451,
  cy: 233.062,
  r: 2.4,
  transform: "rotate(-45 117.451 233.062)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135.553,
  cy: 214.96,
  r: 2.4,
  transform: "rotate(-45 135.553 214.96)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153.655,
  cy: 196.858,
  r: 2.4,
  transform: "rotate(-45 153.655 196.858)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171.757,
  cy: 178.757,
  r: 2.4,
  transform: "rotate(-45 171.757 178.757)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 189.858,
  cy: 160.655,
  r: 2.4,
  transform: "rotate(-45 189.858 160.655)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 207.961,
  cy: 142.553,
  r: 2.4,
  transform: "rotate(-45 207.961 142.553)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 226.062,
  cy: 124.451,
  r: 2.4,
  transform: "rotate(-45 226.062 124.451)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 244.164,
  cy: 106.349,
  r: 2.4,
  transform: "rotate(-45 244.164 106.349)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114.057,
  cy: 265.872,
  r: 2.4,
  transform: "rotate(-45 114.057 265.872)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114.057,
  cy: 265.872,
  r: 2.4,
  transform: "rotate(-45 114.057 265.872)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132.159,
  cy: 247.77,
  r: 2.4,
  transform: "rotate(-45 132.159 247.77)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150.261,
  cy: 229.668,
  r: 2.4,
  transform: "rotate(-45 150.261 229.668)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168.362,
  cy: 211.566,
  r: 2.4,
  transform: "rotate(-45 168.362 211.566)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186.464,
  cy: 193.464,
  r: 2.4,
  transform: "rotate(-45 186.464 193.464)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 204.566,
  cy: 175.362,
  r: 2.4,
  transform: "rotate(-45 204.566 175.362)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 222.668,
  cy: 157.26,
  r: 2.4,
  transform: "rotate(-45 222.668 157.26)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240.77,
  cy: 139.158,
  r: 2.4,
  transform: "rotate(-45 240.77 139.158)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 258.872,
  cy: 121.057,
  r: 2.4,
  transform: "rotate(-45 258.872 121.057)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128.764,
  cy: 280.58,
  r: 2.4,
  transform: "rotate(-45 128.764 280.58)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128.764,
  cy: 280.58,
  r: 2.4,
  transform: "rotate(-45 128.764 280.58)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146.867,
  cy: 262.478,
  r: 2.4,
  transform: "rotate(-45 146.867 262.478)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164.968,
  cy: 244.376,
  r: 2.4,
  transform: "rotate(-45 164.968 244.376)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183.07,
  cy: 226.274,
  r: 2.4,
  transform: "rotate(-45 183.07 226.274)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 201.172,
  cy: 208.172,
  r: 2.4,
  transform: "rotate(-45 201.172 208.172)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 219.274,
  cy: 190.07,
  r: 2.4,
  transform: "rotate(-45 219.274 190.07)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 237.376,
  cy: 171.968,
  r: 2.4,
  transform: "rotate(-45 237.376 171.968)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 255.478,
  cy: 153.866,
  r: 2.4,
  transform: "rotate(-45 255.478 153.866)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 273.58,
  cy: 135.764,
  r: 2.4,
  transform: "rotate(-45 273.58 135.764)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143.472,
  cy: 295.288,
  r: 2.4,
  transform: "rotate(-45 143.472 295.288)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143.472,
  cy: 295.288,
  r: 2.4,
  transform: "rotate(-45 143.472 295.288)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161.574,
  cy: 277.186,
  r: 2.4,
  transform: "rotate(-45 161.574 277.186)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179.676,
  cy: 259.084,
  r: 2.4,
  transform: "rotate(-45 179.676 259.084)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 197.778,
  cy: 240.982,
  r: 2.4,
  transform: "rotate(-45 197.778 240.982)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 215.88,
  cy: 222.88,
  r: 2.4,
  transform: "rotate(-45 215.88 222.88)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 233.982,
  cy: 204.778,
  r: 2.4,
  transform: "rotate(-45 233.982 204.778)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 252.084,
  cy: 186.676,
  r: 2.4,
  transform: "rotate(-45 252.084 186.676)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 270.186,
  cy: 168.574,
  r: 2.4,
  transform: "rotate(-45 270.186 168.574)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 288.288,
  cy: 150.472,
  r: 2.4,
  transform: "rotate(-45 288.288 150.472)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158.18,
  cy: 309.996,
  r: 2.4,
  transform: "rotate(-45 158.18 309.996)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158.18,
  cy: 309.996,
  r: 2.4,
  transform: "rotate(-45 158.18 309.996)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176.282,
  cy: 291.894,
  r: 2.4,
  transform: "rotate(-45 176.282 291.894)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 194.384,
  cy: 273.792,
  r: 2.4,
  transform: "rotate(-45 194.384 273.792)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 212.486,
  cy: 255.69,
  r: 2.4,
  transform: "rotate(-45 212.486 255.69)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 230.588,
  cy: 237.588,
  r: 2.4,
  transform: "rotate(-45 230.588 237.588)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 248.69,
  cy: 219.486,
  r: 2.4,
  transform: "rotate(-45 248.69 219.486)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 266.792,
  cy: 201.384,
  r: 2.4,
  transform: "rotate(-45 266.792 201.384)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 284.894,
  cy: 183.282,
  r: 2.4,
  transform: "rotate(-45 284.894 183.282)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 302.996,
  cy: 165.18,
  r: 2.4,
  transform: "rotate(-45 302.996 165.18)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172.888,
  cy: 324.703,
  r: 2.4,
  transform: "rotate(-45 172.888 324.703)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172.888,
  cy: 324.703,
  r: 2.4,
  transform: "rotate(-45 172.888 324.703)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 190.99,
  cy: 306.601,
  r: 2.4,
  transform: "rotate(-45 190.99 306.601)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 209.092,
  cy: 288.5,
  r: 2.4,
  transform: "rotate(-45 209.092 288.5)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 227.194,
  cy: 270.397,
  r: 2.4,
  transform: "rotate(-45 227.194 270.397)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 245.296,
  cy: 252.296,
  r: 2.4,
  transform: "rotate(-45 245.296 252.296)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 263.398,
  cy: 234.194,
  r: 2.4,
  transform: "rotate(-45 263.398 234.194)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 281.5,
  cy: 216.092,
  r: 2.4,
  transform: "rotate(-45 281.5 216.092)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 299.602,
  cy: 197.99,
  r: 2.4,
  transform: "rotate(-45 299.602 197.99)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 317.703,
  cy: 179.888,
  r: 2.4,
  transform: "rotate(-45 317.703 179.888)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 187.596,
  cy: 339.411,
  r: 2.4,
  transform: "rotate(-45 187.596 339.411)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 187.596,
  cy: 339.411,
  r: 2.4,
  transform: "rotate(-45 187.596 339.411)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 205.698,
  cy: 321.309,
  r: 2.4,
  transform: "rotate(-45 205.698 321.309)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 223.8,
  cy: 303.207,
  r: 2.4,
  transform: "rotate(-45 223.8 303.207)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 241.902,
  cy: 285.105,
  r: 2.4,
  transform: "rotate(-45 241.902 285.105)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 260.003,
  cy: 267.003,
  r: 2.4,
  transform: "rotate(-45 260.003 267.003)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 278.105,
  cy: 248.901,
  r: 2.4,
  transform: "rotate(-45 278.105 248.901)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 296.207,
  cy: 230.8,
  r: 2.4,
  transform: "rotate(-45 296.207 230.8)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 314.309,
  cy: 212.698,
  r: 2.4,
  transform: "rotate(-45 314.309 212.698)",
  fill: "#0076FF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 332.411,
  cy: 194.596,
  r: 2.4,
  transform: "rotate(-45 332.411 194.596)",
  fill: "#0076FF"
}));

var Svg220 = function Svg220(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 343,
    viewBox: "0 0 336 343",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg220, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/220.fe831d06.svg";
export { ForwardRef as ReactComponent };